import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";

const ForexBooking = loadable(() => import("./ForexBooking"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ForexBooking {...props} />
  </ErrorBoundary>
);
